import React from 'react';
import PropTypes from 'prop-types';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers';
import { Icon } from 'semantic-ui-react';
import { FormattedDate } from 'react-intl';

const DefaultTemplate = ({ items, linkTitle, linkHref, isEditMode, data = {} }) => {
  let link = null;
  const href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  const ctaLabel = data?.ctaLabel || data?.buttonLabel || 'Read more';

  return (
    <>
      <div className="items">
        {items.map((item) => {
          const itemUrl = flattenToAppURL(item['@id']);
          const title = item.title || item.id;
          const description = item.description || item.Description;

          const dateValue =
            item.created ||
            item.CreationDate ||
            item.effective ||
            item.EffectiveDate ||
            item.start ||
            null;

          return (
            <div className="listing-item" key={item['@id']}>
              <div className="listing-body">
                {dateValue && (
                  <div className="listingItem__date">
                    <FormattedDate
                      value={new Date(dateValue)}
                      year="numeric"
                      month="long"
                      day="2-digit"
                    />
                  </div>
                )}

                <h3 className="listingItem__title">{title}</h3>

                {description && (
                  <p className="listingItem__description">{description}</p>
                )}

                <div className="listingItem__actions">
                  <UniversalLink
                    href={itemUrl}
                    className="ui button listingItem__cta"
                  >
                    <Icon name="caret right" />
                    {ctaLabel}
                  </UniversalLink>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

DefaultTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkTitle: PropTypes.any,
  linkHref: PropTypes.any,
  isEditMode: PropTypes.bool,
  data: PropTypes.object,
};

export default DefaultTemplate;
